import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class BusinessController 
{
    async create(data) {
        const response = await api.business().post(data);
        return apiCallbackTreatment(response);
    }

    async deleteById(id)
    {
        const response = await api.business().remove(id);
        return apiCallbackTreatment(response);
    }

    async get() 
    {
        const response = await api.business().get();
        return apiCallbackTreatment(response);
    }

    async getById(id) 
    {
        const response = await api.business().getById(id);
        return apiCallbackTreatment(response);
    }

    async update(id, data) {
        const response = await api.business().update(id, data);
        return apiCallbackTreatment(response);
    }
}